import { Mention } from "~/sharedComponents/advancedEditor/types/types";

export const suggestionsFilter = (searchValue: string, suggestions: Mention[]) => {
    const value = searchValue.toLowerCase();

    const filteredSuggestions = !value
        ? suggestions
        : suggestions.filter(suggestion => suggestion.name.toLowerCase().indexOf(value) > -1);

    return filteredSuggestions;
};
